module.exports = __webpack_public_path__ + "973366b64c891bee12820287c1100c15.pdf";